export default {
  ferrum: 'https://github.com/rubycdp/ferrum',
  cuprite: 'https://github.com/rubycdp/cuprite',
  vessel: 'https://github.com/rubycdp/vessel',
  evrone: 'https://evrone.com/ruby'
}
